export const BusinessLabelArchetypeValues = {
  VENDOR: "VENDOR",
  BUYER: "BUYER",
  FINANCIAL: "FINANCIAL",
} as const;

export const BusinessLabelArchetypeLabels: Record<string, string> = {
  [BusinessLabelArchetypeValues.VENDOR]: "Vendor",
  [BusinessLabelArchetypeValues.BUYER]: "Buyer",
  [BusinessLabelArchetypeValues.FINANCIAL]: "Financial",
};
